import aktDvk from './aktDvk';

const documents = {
  aktDvk,
};

export default documents;
